module.exports = __webpack_public_path__ + "static/img/lm_intro.d62bba1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lm_intro.png
// module id = YZys
// module chunks = 0